import { HttpStore } from '@monorepo/controlled/src/stores/http.store';

interface IUseDownload {
	httpStore?: HttpStore<undefined, Blob | null>;
	url?: string;
	fileName: string;
	extension: string;
}

export const useDownload = async ({ httpStore, url, fileName, extension }: IUseDownload) => {
	let href = '';

	if (url) {
		const res = await fetch(url);
		const blob = await res.blob();
		href = window.URL.createObjectURL(blob);
	} else if (httpStore) {
		const res = await httpStore.fetch(undefined)
		href = window.URL.createObjectURL(new Blob([res as Blob]));
	}

	const link = document.createElement('a');
	link.href = href;
	link.setAttribute('download', `${fileName}.${extension}`);
	link.style.display = 'none';
	document.body.appendChild(link);
	link.click();
	document.body.removeChild(link);
};
